import React from 'react';
import { Link } from 'react-router-dom';
import { reportName } from '../../helpers/reportNames';

const Report = props => {
    return (
        <div className="statstics-list__item-link-container">
            <Link className="statstics-list__item-link-btn" to={`/company/${props.companyId}/branch/${props.branchId}/report${props.reportPath}`}>{reportName(props.reportType)}</Link>
        </div>
    );
}

export default Report;